export const PROGRAM = {
    name: "Carbon on Country",
    promise: "Indigenous Environmental Leadership",
};

export const INVESTMENT_AREAS = [
    "Carbon projects",
    "Biodiversity markets",
    "Nature Repair",
    "Natural capital",
    "Restoration",
    "Climate adaptation",
];

export const OPEN_QUESTIONS = [
    "Who will do the work?",
    "Who will monitor outcomes?",
    "Who will assess biodiversity?",
    "Who will verify carbon projects?",
    "Who will manage environmental data?",
    "Who will steward Country for the next generation?",
];

// icons are lucide-react component names
export const CAREERS = [
    {
        icon: "ClipboardCheck",
        title: "Carbon Auditors",
        body: "Supporting project compliance, reporting and verification.",
    },
    {
        icon: "Leaf",
        title: "Nature Repair Auditors",
        body: "Assessing ecological outcomes and restoration performance.",
    },
    {
        icon: "Binoculars",
        title: "Biodiversity Assessors",
        body: "Monitoring species, habitat condition and environmental change.",
    },
    {
        icon: "Activity",
        title: "Natural Capital Monitors",
        body: "Supporting emerging environmental accounting systems.",
    },
    {
        icon: "Trees",
        title: "Restoration Coordinators",
        body: "Managing restoration projects and landscape recovery programs.",
    },
    {
        icon: "Workflow",
        title: "Carbon Project Managers",
        body: "Leading Indigenous-led carbon and environmental projects.",
    },
    {
        icon: "Sprout",
        title: "Seed Collection Specialists",
        body: "Supporting restoration and regeneration through native seed systems.",
    },
    {
        icon: "Database",
        title: "Environmental Data Officers",
        body: "Managing GIS, monitoring and environmental reporting systems.",
    },
];

export const TRAINING_PROGRAMS = [
    "Indigenous Native Seed Collection & Restoration",
    "Carbon Fundamentals",
    "Carbon Project Governance",
    "Biodiversity Monitoring",
    "GIS & Environmental Data Collection",
    "Natural Capital & Nature Repair",
    "Environmental Reporting & Auditing",
    "Indigenous Carbon Project Readiness",
    "Restoration Readiness Assessment",
];

export const LEARNING_ON_COUNTRY = [
    "Walking Country",
    "Monitoring landscapes",
    "Collecting field data",
    "Working with Elders",
    "Participating in restoration projects",
    "Learning from practitioners",
    "Applying knowledge in real-world settings",
];

export const FRAMEWORK = [
    {
        n: "I",
        title: "Knowledge",
        body: "Traditional knowledge and cultural understanding.",
    },
    {
        n: "II",
        title: "Monitoring",
        body: "Measuring environmental change.",
    },
    {
        n: "III",
        title: "Restoration",
        body: "Improving landscape condition.",
    },
    {
        n: "IV",
        title: "Stewardship",
        body: "Long-term care of Country.",
    },
    {
        n: "V",
        title: "Leadership",
        body: "Building local capability and decision-making authority.",
    },
];

export const LEGACY_OUTCOMES = [
    "Skills",
    "Knowledge",
    "Employment",
    "Leadership",
    "Community capability",
];
